import { TFunction } from 'i18next';
import { saveCSV } from '../../../common';
import { DailyAttendanceReportType } from '../types';

// Generate CSV functions
const COLUMNS = [
  { headerKey: 'attendance.dailyTable.nameColumn', dataKey: 'studentName' },
  { headerKey: 'attendance.dailyTable.roomColumn', dataKey: 'roomName' },
  { headerKey: 'attendance.dailyTable.dateColumn', dataKey: 'checkInDate' },
  { headerKey: 'attendance.dailyTable.checkInColumn', dataKey: 'checkInTime' },
  { headerKey: 'attendance.dailyTable.signeeColumn', dataKey: 'checkInName' },
  { headerKey: 'attendance.dailyTable.dateColumn', dataKey: 'checkOutDate' },
  { headerKey: 'attendance.dailyTable.checkOutColumn', dataKey: 'checkOutTime' },
  { headerKey: 'attendance.dailyTable.signeeColumn', dataKey: 'checkOutName' },
];
export function generateDailyAttendanceCSV(dailyAttendanceReport: DailyAttendanceReportType, t: TFunction) {
  const { items: dailyAttendance, endDate, startDate } = dailyAttendanceReport;
  const filename = t('attendance.export.dailyFileName', { startDate, endDate });

  const headers = COLUMNS.map((column) => t(column.headerKey)).join(',') + '\n';
  const body = dailyAttendance
    .map((row) => {
      return [
        row.studentName,
        row.roomName,
        row.checkInDate,
        row.isAbsent ? t('attendance.list.absentStatus') : row.checkInTime,
        row.checkInName,
        row.checkOutDate,
        row.isAbsent ? t('attendance.list.absentStatus') : row.checkOutTime,
        row.checkOutName,
      ].join(',');
    })
    .join('\n');
  const csv = headers + body;
  saveCSV(csv, filename);
}
